'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _redux = require('redux');

var _iamOpenIdConnectImplicitFlow = require('iam-open-id-connect-implicit-flow');

var _reduxResponsive = require('redux-responsive');

var _HabitatLauncher = require('./HabitatLauncher');

var _HabitatLauncher2 = _interopRequireDefault(_HabitatLauncher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AppLauncher = function () {
  function AppLauncher() {
    _classCallCheck(this, AppLauncher);

    if (!window.dkeReactLauncher) {
      window.dkeReactLauncher = {
        appsLength: -1,
        appRegistered: 0,
        routes: [],
        reducers: {
          auth: _iamOpenIdConnectImplicitFlow.authReducer,
          browser: (0, _reduxResponsive.createResponsiveStateReducer)({
            XS: 569,
            SM: 819,
            MD: 1069,
            LG: 1319
          }, {
            infinity: 'XL'
          })
        },
        habitatInstance: null,
        rootReducer: null,
        miniAppRouteNames: [],
        hasSetup: false,
        filteredRoutes: []
      };
      this.searchForApps();
    }
    return this;
  }

  _createClass(AppLauncher, [{
    key: 'setAppsLength',
    value: function setAppsLength() {
      var apps = document.getElementsByClassName('react-mini-app');
      for (var i = 0; i < apps.length; i++) {
        window.dkeReactLauncher.miniAppRouteNames.push(apps[i].getAttribute('data-component'));
      }
      window.dkeReactLauncher.appsLength = apps.length;
    }
  }, {
    key: 'searchForApps',
    value: function searchForApps() {
      this.setAppsLength();
      this.startAllApp();
    }
  }, {
    key: 'addRoutes',
    value: function addRoutes(routes) {
      window.dkeReactLauncher.routes = [].concat(_toConsumableArray(window.dkeReactLauncher.routes), _toConsumableArray(routes));
    }
  }, {
    key: 'addReducers',
    value: function addReducers(redursObj) {
      window.dkeReactLauncher.reducers = Object.assign(window.dkeReactLauncher.reducers, redursObj);
    }
  }, {
    key: 'startAllApp',
    value: function startAllApp(middlewareConfig) {
      this.checkRoutes();
      if (window.dkeReactLauncher.habitatInstance === null && window.dkeReactLauncher.appRegistered >= window.dkeReactLauncher.appsLength && window.dkeReactLauncher.appsLength !== 0) {
        window.dkeReactLauncher.rootReducer = (0, _redux.combineReducers)(window.dkeReactLauncher.reducers);
        window.dkeReactLauncher.habitatInstance = new _HabitatLauncher2.default();
        window.dkeReactLauncher.habitatInstance.startRootApp(window.dkeReactLauncher.filteredRoutes, window.dkeReactLauncher.miniAppRouteNames, middlewareConfig);
      }
    }
  }, {
    key: 'checkRoutes',
    value: function checkRoutes() {
      var numberOfFounds = 0;
      window.dkeReactLauncher.miniAppRouteNames.forEach(function (route) {
        if (window.dkeReactLauncher.routes.find(function (elem) {
          if (!elem.routeName) {
            throw new Error('No route name is provided!');
          }
          if (elem.routeName === route) {
            if (!window.dkeReactLauncher.filteredRoutes.find(function (filteredElem) {
              return filteredElem.routeName === elem.routeName;
            })) {
              window.dkeReactLauncher.filteredRoutes.push(elem);
            }
            return true;
          }
          return false;
        })) {
          numberOfFounds++;
        }
      });
      window.dkeReactLauncher.appRegistered = numberOfFounds;
    }
  }, {
    key: 'startApp',
    value: function startApp(routes, redursObj) {
      var axiosMiddlewareConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.addRoutes(routes);
      this.addReducers(redursObj);
      this.startAllApp(axiosMiddlewareConfig);
    }
  }]);

  return AppLauncher;
}();
// Always export a 'new' instance so it immediately evokes


exports.default = new AppLauncher();